import { render } from "./staff-search-filters.vue?vue&type=template&id=0aa3457d"
import script from "./staff-search-filters.vue?vue&type=script&lang=js"
export * from "./staff-search-filters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__